import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js"

export default class extends Controller {
  static values = {
    surveyValues: Array,
    surveyLabels: Array
  }

  connect() {
    this.initializeChart()
  }

  initializeChart() {
    const canvas = this.element.querySelector("#surveys-chart")
    if (!canvas) return

    new Chart(canvas, {
      type: "line",
      data: {
        datasets: [{
          data: this.surveyValuesValue,
          backgroundColor: "#3498db",
          borderColor: "#3498db",
          fill: false,
        }],
        labels: this.surveyLabelsValue,
      },
      options: {
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              precision: 0,
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: true,
              maxTicksLimit: 15,
            }
          }]
        }
      }
    })
  }
}
